// 表記ゆれの判定に使う形。全角半角・大文字小文字・空白の違いを同じとみなす
export function toTagComparisonKey(name: string): string {
  return name.normalize('NFKC').toLowerCase().replace(/\s+/g, '');
}

// タグのチェックリストに並べる名前。ほかの物件で使われているタグに、この物件に付いているタグ（新しく作ったものを含む）を足し、重複なく並べる
export function getTagOptionNames(existingTagNames: string[], attachedTags: string[]): string[] {
  const names = existingTagNames.concat(attachedTags);
  return Array.from(new Set(names)).sort((a, b) => a.localeCompare(b, 'ja'));
}

export type NewTagCheckResult =
  | { kind: 'ok'; name: string }
  | { kind: 'error'; message: string }
  // 表記ゆれで既存のタグと同じとみなせる。既存のタグを使ってもらう
  | { kind: 'similar'; existingName: string };

// 新しく作るタグ名を確かめる
export function checkNewTagName(
  input: string,
  attachedTags: string[],
  existingTagNames: string[]
): NewTagCheckResult {
  const name = input.trim();
  if (name === '') {
    return { kind: 'error', message: 'タグ名を入力してください' };
  }
  const key = toTagComparisonKey(name);
  if (attachedTags.some(tag => toTagComparisonKey(tag) === key)) {
    return { kind: 'error', message: 'このタグはすでに付いています' };
  }
  const similar = existingTagNames.find(existingName => toTagComparisonKey(existingName) === key);
  if (similar !== undefined) {
    return { kind: 'similar', existingName: similar };
  }
  return { kind: 'ok', name: name };
}
